import {
  AutoCompleteMulti,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import MainApiService from "../../../../../../services/mainApi.service";
import RecommendedSize from "./RecommendedSize";
import { useWatch } from "react-hook-form";
import { TBannerForm } from "../BannerSchema";
const BANNER_LOCALS_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";

const translationPath = "page.register.banners.";

const bannerLocalsService = new MainApiService<ISelectType>(
  BANNER_LOCALS_ROUTE
);

const BannersLocals = () => {
  const { t } = useTranslation();
  const [banners, setBanners] = useState<ISelectType[]>();
  const [allBanners, setAllBanners] = useState<ISelectType[]>();
  const { sendRequest: getBanners, loading: sLoading } = useFetch(
    bannerLocalsService.list
  );

  const { control } = useFormContext<TBannerForm>();

  const bannerLocalsValue = useWatch({
    control,
    name: "bannerLocals",
  });

  const handleFetchBanners = useCallback(async () => {
    const { success, data } = await getBanners({ Identifier: "BANNER_LOCALS" });

    if (success && data) {
      setBanners(data);
      setAllBanners(data);
    }
  }, [setBanners, getBanners, setAllBanners]);

  const handleMiniBannersLogic = useCallback(() => {
    const hasStandardSelection = bannerLocalsValue?.some(
      (x: ISelectType) => x.code !== "6" && x.code !== "7"
    );

    const hasSpecialSelection = bannerLocalsValue?.some(
      (x: ISelectType) => x.code === "6" || x.code === "7"
    );

    if (hasStandardSelection) {
      setBanners(
        allBanners?.filter(
          (banner) => banner.code !== "6" && banner.code !== "7"
        )
      );
    } else if (hasSpecialSelection) {
      setBanners(
        allBanners?.filter(
          (banner) => banner.code === "6" || banner.code === "7"
        )
      );
    } else {
      setBanners(allBanners);
    }
  }, [bannerLocalsValue, allBanners]);

  useEffect(() => {
    handleFetchBanners();
  }, [handleFetchBanners]);

  useEffect(() => {
    handleMiniBannersLogic();
  }, [handleMiniBannersLogic]);

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        size="small"
        options={banners}
        label={t(translationPath + "banner_locals")}
        name="bannerLocals"
        helperText={<RecommendedSize />}
      />
    </Grid>
  );
};

export default memo(BannersLocals);
